export default {
    GLOBAL_HOME: '/',
    INSTAMART_HOME: '/',
    EXTERNAL_LOGIN: '/login',
    EMPLOYEE_LOGIN: '/employee-login',
    LOGIN_SUCCESS: '/login/success',
    MOCK_THIRD_PARTY_LOGIN: '/mock/third-party-login',
    ACCOUNT_SELECT: '/account-select',
    INSTAMART: {
        CAMPAIGN_EDIT: '/campaign/{0}/edit',
        CAMPAIGN_CREATE: '/campaign/create',
        CAMPAIGN_DETAILS: '/campaign/{0}',
        CAMPAIGN_LIST: '/campaign/list',
    },
};
